import { render, staticRenderFns } from "./HeadLessLayout.vue?vue&type=template&id=37860b5d&scoped=true&"
import script from "./HeadLessLayout.vue?vue&type=script&lang=ts&"
export * from "./HeadLessLayout.vue?vue&type=script&lang=ts&"
import style0 from "./HeadLessLayout.vue?vue&type=style&index=0&id=37860b5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37860b5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/zfh/dev/targus-micor/targus-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37860b5d')) {
      api.createRecord('37860b5d', component.options)
    } else {
      api.reload('37860b5d', component.options)
    }
    module.hot.accept("./HeadLessLayout.vue?vue&type=template&id=37860b5d&scoped=true&", function () {
      api.rerender('37860b5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/HeadLessLayout.vue"
export default component.exports